import {
  ChangeDetectionStrategy,
  Component, EventEmitter, Inject,
  Input, OnChanges,
  Output, SimpleChanges,
} from "@angular/core";
import {VisitPlanModel} from "../../../models/visit-plan.model";
import {VisitPlanJobModel} from "../../../models/visit-plan-job.model";
import {ServiceType} from "../../../../deliveries/types/service.type";

require('./visit-plan-jobs-panel-item.scss');
@Component({
  standalone: false,
  selector: 'app-visit-plan-jobs-panel-item',
  templateUrl: './visit-plan-jobs-panel-item.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VisitPlanJobsPanelItemComponent {

  @Input() job: VisitPlanJobModel;
  @Input() visitPlan: VisitPlanModel;
  @Input() programTypeAliasMap: { [key: string]: string };
  @Input() isSelected: boolean;
  @Output() onToggle = new EventEmitter<string>();
  @Output() onLockJobChange = new EventEmitter<{ id: string, locked: boolean }>();

  public serviceTypes: typeof ServiceType = ServiceType;
  public isHovered: boolean = false;

  constructor(
    @Inject('$timeout') private $timeout
  ) {
  }

  onToggleSelected(){
    this.onToggle.emit(this.job.id);
    this.$timeout(0).then(() => {
      // this._setChatUnreadCount();
    });
  }

  onToggleLock() {
    this.onLockJobChange.emit({ id: this.job.id, locked: !this.job.lockedToRoute });
  }

}
